import type { ReactNode } from 'react';

/** Tooltip propio que aparece directo al hacer hover, en vez de depender del `title` nativo del
 * navegador (con delay y poco visible). Mismo patrón group-hover que ya se usa en otros lados de
 * admin (ver los botones de aprobar/rechazar en AdminRevisionDetailPage). */
export interface TooltipProps {
  label: string;
  children: ReactNode;
  className?: string;
  position?: 'top' | 'bottom';
  align?: 'center' | 'left' | 'right';
  maxWidth?: string;
}

/** Tooltip propio que aparece directo al hacer hover con wrapping seguro para evitar desbordamiento */
export function Tooltip({ label, children, className = '', position = 'top', align = 'center', maxWidth = 'max-w-[220px]' }: TooltipProps) {
  const positionClasses = position === 'bottom' ? 'top-full mt-1.5' : 'bottom-full mb-1.5';

  const alignClasses =
    align === 'left' ? 'left-0 translate-x-0' : align === 'right' ? 'right-0 translate-x-0' : 'left-1/2 -translate-x-1/2';

  return (
    <span className={`relative inline-flex group/tooltip ${className}`}>
      {children}
      <span
        role="tooltip"
        className={`absolute ${positionClasses} ${alignClasses} ${maxWidth} w-max px-2.5 py-1.5 rounded-lg bg-gray-900/95 text-white text-[11px] font-medium leading-snug text-center whitespace-normal break-words shadow-lg border border-gray-700/50 opacity-0 pointer-events-none group-hover/tooltip:opacity-100 transition-opacity duration-150 z-50`}
      >
        {label}
      </span>
    </span>
  );
}
